export const ALL_ORGS_PREFIX = 'all-orgs';
export const ADMIN_RESET_EVENT = 'admin:reset-to-default';
export const ADMIN_CONTENT_READY_EVENT = 'admin:content-ready';
export const LIVEBOARD_PREFIX = 'visual-embed-liveboard_';
export const LIVEBOARD_SLUG_PREFIX = 'liveboard/';
export const SLUG_TO_TAB_ID = {
    'user-management/users': 'modern-user-management',
    'user-management/groups': 'modern-user-management',
    'user-management/roles': 'modern-user-management',
    'user-management/authentication': 'modern-user-management',
    'user-management': 'modern-user-management',
    'authentication/saml': 'authentication-saml',
    'authentication/mfa': 'authentication-mfa',
    'authentication/provisioning': 'authentication-provisioning',
    'authentication/active-directory': 'authentication-active-directory',
    'authentication/internal-auth': 'authentication-local',
    'style-customization': 'settings-style-customization-react',
    customization: 'settings-style-customization-react',
    'customization/styles': 'settings-style-customization-react',
    'customization/charts': 'settings-style-customization-react',
    'customization/homepage': 'settings-style-customization-react',
    'customization/email': 'settings-style-customization-react',
    'customization/help': 'settings-style-customization-react',
    'chart-customization': 'chart-customization',
    'help-customization': 'settings-help-customization',
    'email-customizations': 'email-customizations',
    'feature-management': 'feature-management',
    'feature-management/general': 'feature-management',
    'feature-management/early-access': 'feature-management',
    'csv-upload': 'csv-upload',
    'version-control': 'version-control-system',
    'homepage-discovery': 'homepage-and-discovery',
    'app-settings': 'application-settings',
    'app-settings/general': 'application-settings',
    'app-settings/modeling': 'application-settings',
    'app-settings/csv-upload': 'application-settings',
    security: 'settings-security',
    ssl: 'settings-ssl',
    'reverse-ssh': 'settings-rev-ssh',
    smtp: 'settings-smtp',
    'backup-storage': 'backup-storage',
    'scheduled-maintenance': 'scheduled-maintenance',
    alerts: 'system-alerts',
    cluster: 'system-cluster-details',
    'table-status': 'system-table-status',
    orgs: 'org-management-organizations',
    'org-management': 'modern-org-management',
    pricing: 'pricing',
    'manage-subscription': 'manage-subscription',
    'data-usage': 'data-usage',
    'user-adoption': 'visual-embed-liveboard_bea79810-145f-4ad0-a02c-4177a6e7d861_7ab58fe5-d137-4e58-995d-ebd11850d472',
    'app-performance': 'visual-embed-liveboard_a1cd9526-f25a-443b-8a35-75d0adc6e04f',
    'object-usage': 'visual-embed-liveboard_74852035-9624-4fac-b352-200fa8506b14_01006fc1-3b13-4144-8654-325a3a1fbe1d',
    'ai-bi-stats': 'visual-embed-liveboard_3e08c798-a5cb-4ae9-b54e-c03bf35243ef_452fc06a-7656-4d90-b985-5fe2056b2c63',
    'indexing-queries': 'system-activities-indexing-queries',
    'credit-usage': 'visual-embed-liveboard_9beaacbf-e65b-4416-b110-238d109c3531',
    'credit-usage-saas': 'visual-embed-liveboard_41a39422-2da0-4601-9d4a-59c27181c5f5',
    'billable-query-stats': 'visual-embed-liveboard_0ee6fb0f-e7bf-4042-8d5d-c90d0412bf6c',
    onboarding: 'tscli-ui-onboarding',
    'early-access': 'tscli-ui-early_access_feature',
    'downloads-schedules': 'tscli-ui-downloadsAndSchedules',
    modeling: 'tscli-ui-dataModelling',
    administration: 'tscli-ui-administration',
    'sage-feature': 'tscli-ui-sage_feature',
    search: 'tscli-ui-search',
    variables: 'variables',
    'user-agreement': 'user-agreement',
    'spotter-users': 'spotter-users-list',
};
export const TAB_ID_TO_SLUG = {
    'modern-user-management': 'user-management',
    'modern-org-management': 'org-management',
    'settings-style-customization-react': 'style-customization',
    'application-settings': 'app-settings',
    'feature-management': 'feature-management',
    ...Object.fromEntries(Object.entries(SLUG_TO_TAB_ID)
        .filter(([, tabId]) => tabId !== 'modern-user-management' &&
        tabId !== 'modern-org-management' &&
        tabId !== 'settings-style-customization-react' &&
        tabId !== 'application-settings' &&
        tabId !== 'feature-management')
        .map(([slug, tabId]) => [tabId, slug])),
};
export const CUSTOMIZATION_SCREEN_IDS = new Set([
    'settings-style-customization-react',
    'chart-customization',
    'homepage-and-discovery',
    'email-customizations',
    'settings-help-customization',
]);
export const CUSTOMIZATION_SCREEN_ID_TO_SLUG = {
    'settings-style-customization-react': 'customization',
    'chart-customization': 'customization/charts',
    'homepage-and-discovery': 'customization/homepage',
    'email-customizations': 'customization/email',
    'settings-help-customization': 'customization/help',
};
//# sourceMappingURL=admin-route-constants.js.map